/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react'
import {
  useRecordContext,
  Identifier,
  useTranslate,
  useRedirect,
  useResourceContext,
  Button,
  useDelete,
  useNotify,
} from 'react-admin'
import { Alert } from '@mui/material'
import ShowIcon from '@mui/icons-material/Visibility'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'

interface ActionButtonProps {
  iconOnly?: boolean
  showButton?: boolean
  editButton?: boolean
  deleteButton?: boolean
}

export const ActionButton: React.FC<ActionButtonProps> = (props): JSX.Element => {
  const { iconOnly = false, showButton = true, editButton = true, deleteButton = true } = props
  const translate = useTranslate()
  const resource = useResourceContext()
  const redirect = useRedirect()
  const record = useRecordContext(props)
  const notify = useNotify()
  const [deleteOne, { data, isLoading, error }] = useDelete(resource, {
    id: record.id,
    previousData: record,
  })

  const deleteRecord = async (id: Identifier): Promise<void> => {
    await deleteOne()
    if (!error) {
      notify(
        <Alert severity='success' key={0}>
          Deleted
        </Alert>,
      )
    } else {
      notify(
        <Alert severity='error' key={0}>
          Error!
        </Alert>,
      )
    }
  }
  return (
    <>
      {showButton && (
        <Button
          label={!iconOnly ? translate('ra.action.show') : null}
          startIcon={<ShowIcon />}
          color='primary'
          size='small'
          onClick={(): void => {
            redirect('show', resource, record.id)
          }}
        />
      )}
      {editButton && (
        <Button
          label={!iconOnly ? translate('ra.action.edit') : null}
          startIcon={<EditIcon />}
          color='primary'
          size='small'
          onClick={(): void => {
            redirect('edit', resource, record.id)
          }}
        />
      )}
      {deleteButton && (
        <Button
          label={!iconOnly ? translate('ra.action.delete') : null}
          startIcon={<DeleteIcon />}
          color='error'
          size='small'
          onClick={(): void => {
            if (confirm(`Delete ID: ${record.id} ?`) == true) {
              deleteRecord(record.id)
            }
          }}
        />
      )}
    </>
  )
}
